module.exports = __webpack_public_path__ + "static/media/defaultThumb.0e3c4189.svg";